import { useEffect, useCallback } from 'react'

export const useLoadingMore = ({
  selector,
  skip = false,
  onLoadMore,
  root = null,
  threshold = 0.1,
  rootMargin = '0px'
}) => {
  const callback = useCallback(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onLoadMore()
        }
      })
    },
    [onLoadMore]
  )

  useEffect(() => {
    if (skip) return

    const target = document.querySelector(selector)

    if (!target) return

    const observer = new IntersectionObserver(callback, {
      root,
      threshold,
      rootMargin
    })

    observer.observe(target)

    return () => {
      observer.disconnect()
    }
  }, [selector, skip, callback, root, threshold, rootMargin])
}
